var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{class:[
    'uik-tag__wrapper',
    {'uik-tag__nowrap': _vm.nowrap},
    {'uik-tag__collapsed': _vm.collapsed},
    (_vm.fill ? 'uik-tag__fill':''),
    (_vm.color != '' ? _vm.color:'')
]},[_c('span',{staticClass:"uik-tag__content"},[_vm._v(" "+_vm._s(_vm.text)+" "),_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }